import { Dataset } from '../../../types/types';
import { getItemsParamArray } from '../../../utils/apiRequests/getItemsParamArray';

// Reference rows are keyed by control.idItem; ensure that column is fetched
// even when it is hidden or differs from the dataset key column.
export const getReferenceItemsParamArray = (
  dataset: Dataset,
  controlIdItem: string
): string[] => {
  const items = getItemsParamArray(dataset);
  if (controlIdItem && !items.includes(controlIdItem)) {
    items.push(controlIdItem);
  }
  return items;
};
